import { useQuery } from '@tanstack/react-query';
import { usePOSCoreApiClient } from 'utils/apiClient/services/core/index';

const useLoginUserInfo = () => {
  const coreApiClient = usePOSCoreApiClient();
  const userToken = localStorage.getItem('account')
    ? JSON.parse(localStorage.getItem('account') as string)?.userToken
    : undefined;
  return useQuery({
    queryKey: ['account', 'loginUserInfo'],
    queryFn: async () => {
      const result = await coreApiClient.loginUserInfo();
      return result;
    },
    enabled: !!userToken,
    retry: false,
  });
};

export default useLoginUserInfo;
